import ReactDOM from 'react-dom';
var RootPortal = function RootPortal(_ref) {
    var children = _ref.children;
    var portal = document.getElementById('root-portal');
    if (!portal)
        return null;
    return /*#__PURE__*/ ReactDOM.createPortal(children, portal);
};
export default RootPortal;
